import React from "react";
import "../styles/base/animations.css";

const TableSkeleton = ({ rows = 8 }) => {
  return (
    <div className="table-skeleton-wrapper">
      {Array.from({ length: rows }).map((_, i) => (
        <div className="table-skeleton-row" key={i}>
          <div className="table-skeleton-cell w-sm" />
          <div className="table-skeleton-cell w-md" />
          <div className="table-skeleton-cell w-lg" />
          <div className="table-skeleton-cell w-xl" />
          <div className="table-skeleton-cell w-flex" />
          <div className="table-skeleton-badge" />
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
